import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuthentication } from '~/components/Authentication/useAuthentication';
import AuthForm from '~/components/AuthForm/AuthForm';
import './Login.scss';
import { useContext, useEffect } from 'react';
import { AuthenticationContext } from '~/components/Authentication/AuthenticationProvider';
import { checkIfFoodAdmin } from '~/utils/getUserRole';
import i18next from 'i18next';
import { versionData } from '~/utils/versionData';
import { useToastWarning } from '~/utils/useToastWarning';

const Login = (): JSX.Element => {
  const { authenticated } = useAuthentication();
  const { user } = useContext(AuthenticationContext);
  const isFoodAdmin = checkIfFoodAdmin(user?.data.role_name);
  const [searchParams] = useSearchParams();
  const toastWarning = useToastWarning();

  useEffect(() => {
    if (searchParams.get('reason') === 'session_expired') {
      toastWarning(i18next.t('session_expired'));
    }
  }, []);

  if (authenticated) {
    if (isFoodAdmin) {
      return <Navigate to="/transactions" />;
    }
    return <Navigate to="/accommodations" />;
  }

  return (
    <div className="loginPage" style={{ position: 'relative' }}>
      <AuthForm />
      <span className="version">{i18next.t('version')} {versionData.version}</span>
    </div>
  );
};

export default Login;
